export default __webpack_public_path__ + "static/GRID22-25-countries-ce90bd6a420e39303dd2cd71fbf620bb.png";